import { FormikValues } from 'formik'

export interface UpdateIssuerTierFormValues extends FormikValues {
  instrumentCode: string
  tier: string
}

export const updateIssuerTierValues: UpdateIssuerTierFormValues = {
  instrumentCode: '',
  tier: '',
}

export const tiersByInstrument = {
  TD: {
    1: 'Major',
    2: 'A Rated',
    3: 'BBB Rated',
    4: 'Unrated',
    5: 'Demo',
  },
  CP: {
    1: 'Major',
    2: 'Demo',
  },
  CD: {
    1: 'Major',
    2: 'Demo',
  },
}

export const instrumentTiers = ['TD', 'CD', 'CP']
